// extracted by mini-css-extract-plugin
export default {"bg_shadow":"DataQuestion_bg_shadow__9AYNw","question":"DataQuestion_question__3DJGt"};